import React, { useEffect, useMemo, useState } from "react";

export default function ForwardMessageModal({
  sourceConversationLabel,
  conversations,
  activeConversationId,
  senderLabel,
  previewText,
  onClose,
  onForward,
}) {
  const [filter, setFilter] = useState("");
  const [submittingId, setSubmittingId] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    function onKeyDown(event) {
      if (event.key === "Escape" && !submittingId) onClose();
    }
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onClose, submittingId]);

  const filteredConversations = useMemo(() => {
    const query = filter.trim().toLowerCase();
    if (!query) return conversations;
    return conversations.filter((conversation) => {
      return (
        conversation.title.toLowerCase().includes(query)
        || conversation.subtitle.toLowerCase().includes(query)
      );
    });
  }, [conversations, filter]);

  async function handleForward(conversationId) {
    if (!conversationId || submittingId) return;
    setSubmittingId(conversationId);
    setError(null);
    try {
      await onForward(conversationId);
    } catch (err) {
      setError(err.message || "Couldn't forward message.");
      setSubmittingId("");
    }
  }

  return (
    <div className="chat-modal-bg" onClick={submittingId ? undefined : onClose}>
      <div className="chat-modal" onClick={(event) => event.stopPropagation()}>
        <h2>Forward message</h2>
        <div className="chat-forward-preview">
          <span>From {senderLabel} in {sourceConversationLabel}</span>
          <p>{previewText}</p>
        </div>
        <input
          autoFocus
          placeholder="Search chats"
          value={filter}
          onChange={(event) => setFilter(event.target.value)}
          className="chat-modal-search"
          disabled={!!submittingId}
        />
        <div className="chat-modal-userlist">
          {filteredConversations.length === 0 ? (
            <div className="chat-muted">No chats match.</div>
          ) : (
            filteredConversations.map((conversation) => (
              <button
                key={conversation.id}
                type="button"
                className="chat-conversation-row"
                onClick={() => handleForward(conversation.id)}
                disabled={!!submittingId}
              >
                <div
                  className="chat-avatar sm"
                  style={{ background: conversation.avatarBg }}
                  aria-hidden="true"
                >
                  {conversation.avatarText}
                </div>
                <div className="chat-conversation-meta">
                  <div className="chat-conversation-title">{conversation.title}</div>
                  <div className="chat-conversation-subtitle">{conversation.subtitle || "Chat"}</div>
                </div>
                {conversation.id === activeConversationId && (
                  <span className="chat-conversation-tag">Current</span>
                )}
              </button>
            ))
          )}
        </div>
        {error && <div className="chat-auth-error">{error}</div>}
        <div className="chat-modal-footer">
          <button className="chat-btn-link" onClick={onClose} disabled={!!submittingId}>Cancel</button>
        </div>
      </div>
    </div>
  );
}